<script>
import Layout from "../../layouts/home";
import countTo from 'vue-count-to';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
import BannerApi from "@/services/banner-api";
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

import Contactus from "./contact-us.vue";


export default {
  /*page: {
    title: "Page d'Accueil",
    meta: [{ name: "description", content: appConfig.description }]
  },*/
  components: {
    Layout,countTo, swiper, swiperSlide, Contactus
  },
  data() {
    return {

      counterVisible: false,
      keyCounterVisible:0,

      mediaFeaturesVisible: false,
      iconsVisible: false,


      isBannerTableBusy: false,
      mediaFeatures: [
      {
        id: "1",
        icon: "media-oem",
        alt: "users-2-svgrepo-com",
        title: "DES PIÈCES DE QUALITÉ D’ORIGINE",
        description: "Nous mettons un point d’honneur à vous proposer exclusivement des pièces de qualité équivalente à l’origine. La majorité de nos fournisseurs équipent en première monte les plus grands constructeurs automobiles"
      },
      {
        id: "5",
        icon: "media-team",
        alt: "recycling-recycle",
        title: "UNE ÉQUIPE QUALIFIÉE À VOTRE ÉCOUTE",
        description: "Nos équipes techniques vous accompagnent avec professionnalisme dans le choix de vos pièces, en vous proposant des solutions adaptées à vos besoins spécifiques."
      },
      {
        id: "2",
        icon: "media-warranty",
        alt: "qr-code-interactive",
        title: "DES PIÈCES GARANTIES",
        description: "Nous collaborons avec les leaders mondiaux de l’équipement automobile. Toutes nos pièces sont garanties, et en cas de défaut, nos clients bénéficient gratuitement d’un rapport d’expertise pour un traitement rapide et transparent."
      },
      // {
      //   id: "3",
      //   icon: "target-2-svgrepo-com",
      //   alt: "target-2-svgrepo-com",
      //   title: "UN RAPPORT QUALITÉ / PRIX IMBATTABLE",
      //   description: "Soucieux de l’évolution de notre marché et de la concurrence, nous vous proposons constamment les meilleures pièces aux meilleurs prix."
      // },
      // {
      //   id: "4",
      //   icon: "data-folder-svgrepo-com",
      //   alt: "data-folder-svgrepo-comP",
      //   title: "UNE DISPONIBILITÉ IMMÉDIATE",
      //   description: "Notre magasin dispose de plus de 10 000 références en stock, et plus de 100 000 disponibles dans un délai de 7 à 15 jours."
      // },
      
      ],

      swiperOption: {
        slidesPerView: 6,
        loop: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false
        },
        breakpoints: {
          320: {
            slidesPerView: 2
          },
          768: {
            slidesPerView: 3
          },
          1024: {
            slidesPerView: 6
          }
        },
        spaceBetween: 20
      },

      brands: [
        { name: 'Mercedes-Benz', image: require('@/assets/images/mercedes.png') },
        { name: 'BMW', image: require('@/assets/images/bmw.png') },
        { name: 'Mini', image: require('@/assets/images/mini.png') },
        { name: 'Land Rover', image: require('@/assets/images/landrover.png') },
        { name: 'Smart', image: require('@/assets/images/smart.png') },

        { name: 'Jaguar', image: require('@/assets/images/jaguar.png')},
        { name: 'Porsche', image: require('@/assets/images/porsche.png')},

        { name: 'Kia', image: require('@/assets/images/kia.png')},
        { name: 'Hyundai', image: require('@/assets/images/hyundai.png')},





      ],

      counterItems: [
        {
          alt: 'bag',
          width: '70px',
          icon: 'bag-w.svg',
          endVal: 300,
          duration: 2000,
          moreThan: 'plus de',
          title: 'Clients satisfaits',
        },
        {
          alt: 'bread',
          width: '70px',
          icon: 'bread.svg',
          endVal: 40000,
          duration: 2000,
          moreThan: 'plus de',
          title: 'Livraisons par an',
        },
        {
          alt: 'capsules',
          width: '70px',
          icon: 'capsules.svg',
          endVal: 40,
          duration: 2000,
          moreThan: 'plus de',
          title: 'Années d\'expérience',
        },

        {
          alt: 'capsules',
          width: '70px',
          icon: 'capsules.svg',
              endVal: 24,
              duration: 1000,
              title: 'Livraison 24h partout en Tunisie',
        }
      ]


    };
  },

  computed: {
    windowWidth() {
      return window.innerWidth;
    },
  },

  watch:{
    mediaFeaturesVisible(newValue){
      if(newValue){
      this.observeIcons()
      }
    },
    iconsVisible(newValue){
      if(newValue){
      this.observeIcons()
      }
    },

    counterVisible(newValue) {
      if (newValue) {
        this.keyCounterVisible ++
      }
    }
  },

  mounted() {
    /*this.findBanner(this.windowWidth);*/
    this.initIntersectionObserver()
    this.initIntersectionObserverIconsSection()
    /*this.observeImages()
    this.observeImagesRight()*/
    this.initIntersectionCounterObserver()
  },

  methods: {

    initIntersectionCounterObserver() {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.counterVisible = true;
            }
          });
        },
        { threshold: 0.1 }
      );
      observer.observe(this.$refs.counterSection);
    },

    findBanner(windowWidth) {
      this.isBannerTableBusy = true;
      BannerApi.getBanners(windowWidth).then((result) => {
        this.bannerList = result;
        
      }).finally(() => {
        this.isBannerTableBusy = false;
      })
    },

    initIntersectionObserver() {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.mediaFeaturesVisible = true;
            }
          });
        },
        { threshold: 0.1 }
      );
      observer.observe(this.$refs.mediaFeaturesSection);
    },

    initIntersectionObserverIconsSection() {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.iconsSection = true;
            }
          });
        },
        { threshold: 0.1 }
      );
      observer.observe(this.$refs.mediaFeaturesSection);
    },


    observeImagesRight() {
      const images = document.querySelectorAll('.image-slide-right-in');

      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate');
            observer.unobserve(entry.target);
          }
        });
      }, 
      { threshold: 0.1,}
    );

      images.forEach(image => {
        observer.observe(image);
      });
    },

    observeImages() {
      const images = document.querySelectorAll('.image-slide-in');

      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate');
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.1,
      });

      images.forEach(image => {
        observer.observe(image);
      });
    },
    
    observeIcons() {
      const images = document.querySelectorAll('.fadeInUp');

      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate');
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.1,
      });

      images.forEach(image => {
        observer.observe(image);
      });
    }

  }
};
</script>

<template>
  <Layout>

    <!-- Main Banners -->
    <div class="row pt-xl-0 d-none d-lg-block" >
      <!-- <div class="col-xl-9 col-sm-12 col-md-8" > -->
      <div class="col-12" >
        <div class="p-0" >
            <b-carousel
              style="box-shadow:0 2px 6px 0 rgb(0 0 0 / 8%);"
                img-width="1920"
                img-height="400" 
                :interval="6000"
                

                :controls="false"
                :indicators="false"
                :no-hover-pause="false"
                :no-touch="false"
                :fade="true">

              

                <b-carousel-slide>
                  <template #img>
                    <div class="banner-overlay"></div>

                    <img class="banner-image" width="100%" height="100%" style="min-height:650px;" src="@/assets/images/home-banner.png"   />

                  </template>
                

                  <div>

                  

                  </div>

                </b-carousel-slide>
                
                <div  class="carousel-caption text-left d-none d-md-block">
                   
                    <h1 class="font-weight-bold banner-title text-uppercase text-white" style="font-size:3rem !important;">Distributeur de pièces Automobile</h1>
                    <h3 class="d-none d-sm-block text-white mt-4 mb-4 banner-title" style="font-size:1.6rem !important;"> Mercedes-Benz, BMW, Smart, Mini & Land Rover </h3>

                    <div class="new-brands-row" aria-label="Nouvelles marques">
                      <div v-for="brand in ['Porsche', 'Jaguar', 'KIA', 'Hyundai']" :key="brand" class="new-brand">
                        <span class="new-brand-label">NOUVEAU</span>
                        <span class="new-brand-name">{{ brand }}</span>
                      </div>
                    </div>

                          <hr class="separator-line mt-3 mb-5" style="margin:0px !important; width: 20% !important;">


                     <h2 class="d-none d-lg-block text-secondary font-weight-bold font-size-16 mt-5 banner-title" style="max-width: 50%;">
                        <a href="tel:+21674204700" class="mr-1 text-white" style="text-decoration: underline;">+216 74 204 700</a>, 
                        <a href="mailto:contact@sopiq.tn" class="text-white" style="text-decoration: underline;">contact@sopiq.tn</a>
                      </h2>

                      

                  <h2 class="d-none d-lg-block text-secondary font-weight-bold font-size-14 mt-2 banner-title" style="max-width: 50%;">
                    Immeuble El Yosr Avenue Farhat Hached 3000 Sfax					
                  </h2>

                 


                  <div class="mt-5">
                    <a class="pr-3" href="/login">
                      <b-button variant="light"  style="padding: 10px 26px; letter-spacing:3px;" class="font-weight-bold font-size-18">
                          <div style="font-size: 12px; letter-spacing: 1px; text-transform: uppercase; opacity: 0.8; margin-bottom: 6px;">
                            Cliquez et accédez à votre
                          </div>
                         <span class="text-warning text-uppercase">Espace Clients </span>
                      </b-button>
                    </a>    
                    
                    <!-- <a class="pl-3" href="/devenir-partenaire">
                      <b-button variant="light"  style="padding: 10px 26px; " class="font-weight-bold font-size-18">
                        <div class="font-weight-normal font-size-12">Découvrez notre </div>
                        Catalogue d'articles
                      </b-button>   
                    </a> -->
                  </div>
                </div>
                
              
            </b-carousel>



        </div>
      </div>


    </div>


      <div  class="text-center pt-0 pr-3 pl-3 pb-4 p-md-3 d-lg-none d-block bg-light">
          <img src="@/assets/images/logo-dark.png" class="mt-4" alt height="80" />
          <!-- <h1 class="font-weight-bold banner-title-white text-primary text-uppercase"  ><span class="text-primary">Pu</span><span class="text-primary">b</span><span class="text-primary">ag</span> <sup>®</sup></h1> -->
          <h3 class="d-md-none d-block text-primary mt-4 banner-title-mobile" style="font-size:1rem !important;">Distributeur de pièces Automobile</h3>

        <h2 class="d-lg-none d-block text-primary font-weight-bold font-size-20 mt-3 mb-4 banner-title-mobile" style="font-size:1rem !important;">
          Mercedes-Benz, BMW, Smart, Mini & Land Rover
        </h2>

        <div class="new-brands-row mobile-new-brands" aria-label="Nouvelles marques">
          <div v-for="brand in ['Porsche', 'Jaguar', 'KIA', 'Hyundai']" :key="brand" class="new-brand">
            <span class="new-brand-label">NOUVEAU</span>
            <span class="new-brand-name">{{ brand }}</span>
          </div>
        </div>

        <h2 class="d-lg-none d-block text-primary font-weight-bold font-size-18 mt-5 banner-title-mobile" style="font-size:1rem !important;">
            <div class=""><a href="tel:+21674204700" class="mr-1 text-dark" style="text-decoration: underline;">+216 74 204 700</a></div>
            <div class="pt-2"><a href="mailto:contact@sopiq.tn" class="text-dark" style="text-decoration: underline;">contact@sopiq.tn</a></div>
        </h2>

        

        <div class="mt-4 text-center">
            <a href="/login">
              <b-button variant="warning"  style="padding: 10px 26px; letter-spacing:3px;" class="font-weight-bold font-size-18">
                  <!-- <div style="font-size: 12px; letter-spacing: 1px; text-transform: uppercase; opacity: 0.8; margin-bottom: 6px;">
                    Cliquez et accédez à votre
                  </div> -->
                  <span class="text-uppercase text-white">Espace Clients </span>
              </b-button>
            </a>      
        </div>

      </div>

    <!-- 5 points section -->
    <div id="presentation" class="pt-4 text-center bg-white ">
      
      <div class="pt-5 text-primary font-weight-bold " style="font-size:2rem;">
        Qui sommes-nous ?
      </div>

      <hr class="separator-line mt-3 mb-3">


      <div class="header-60-width font-size-20 mx-auto text-primary text-wrap mt-5  text-justify" >
        Depuis 1982, SOPIQ est votre partenaire de confiance dans la distribution de pièces de rechange d’origine et de qualité équivalente, issues des plus grands équipementiers
automobiles mondiaux.
Grâce à notre expertise, notre réactivité et notre engagement envers la satisfaction client, nous
avons su bâtir une réputation solide et accompagner durablement la croissance de nos
partenaires.
Toujours à l’écoute des besoins du marché, nous élargissons continuellement notre gamme
pour mieux répondre à vos exigences.
      </div>

     

    </div>


    <div class="bg-white pt-md-5 pt-md-5 pt-3 pb-md-5">
          <div ref="mediaFeaturesSection" class="header-60-width row pt-md-4 pt-1 text-center  justify-content-center ">
            <div 
              v-for="(feature, index) in mediaFeatures" 
              :key="feature.id"  
              class="col-md-4 col-12 mb-4 mt-4 pr-md-5 pr-0 fadeInUp" 
              :style="{ animationDelay: (index * 0.05) + 's' }"
              ref="mediaFeatureElements"
            >


            
              <img 
                :alt="feature.alt" 
                class="mb-2 " 
                v-if="feature.icon" 
                :src="require('@/assets/icons/' + feature.icon + '.svg')" 
                width="100px"
              > 
              <h4 class=" mt-3 mb-2 font-weight-bold text-primary text-uppercase">{{ $t(feature.title) }}</h4>
              <p class="mt-4 text-primary font-size-14  text-justify">{{ $t(feature.description) }}</p>
            </div>
        </div>

    </div>


    <!--  Counter Section  -->
    <div class="bg-white pt-3 pb-md-5 ">

      <div class="bg-light" >
          



                <div ref="counterSection" class="text-white">
            <div>
                <div class="row p-md-4 -0">
                  <div class="col-12 text-center">
                      <div class="row ml-md-4 ml-0 mr-md-4 mr-0 pt-3 pb-3">
                      <div 
                          v-for="(item, index) in counterItems" 
                          :key="index" 
                          class="col-lg-3 col-12 text-center pt-lg-0 pt-4 pb-md-0 pb-4 "
                      >
                          <!-- <h2>
                          <img :alt="item.alt" :width="item.width" :src="require(`@/assets/icons/${item.icon}`)   " class="mr-0" />
                          </h2> -->

                          <span class="d-none d-lg-inline text-primary font-size-16">{{item.moreThan}} </span>

                          <countTo 
                          :key="keyCounterVisible"
                          class="m-2 text-warning"
                          style="font-weight:900; font-size:2rem; letter-spacing: 0.1em;" 
                          :autoplay="counterVisible" 
                          separator=" " 
                          :startVal="0" 
                          :endVal="item.endVal" 
                          :duration="item.duration"
                          />

                          <h5 class="text-center mt-2 text-primary font-weight-bold">{{ item.title }}</h5>
                          
                      </div>
                      </div>
                  </div>
                </div>

            </div>
            </div>


      </div>


    </div>


    
    
    <!-- Interactive Section -->
    <div id="brands" class="bg-white pt-md-5 pt-5 pb-md-5">


      <div class="text-primary text-center font-weight-bold " style="font-size:2rem;">
        Marques de véhicules
      </div>

      <hr class="separator-line mt-3 mb-3">


      <div class="mt-5 mb-5">
      

        <div class="header-60-width row text-center justify-content-center">
          <div class="col-md-12 col-12">
            <p class="text-primary font-size-20 text-justify">
              Nous proposons une large gamme de pièces de rechange adaptées aux marques suivantes : Mercedes-Benz, BMW, Smart, Mini et Land Rover. 
              Explorez notre catalogue pour trouver rapidement les pièces correspondant à votre véhicule.
            </p>
          </div>
        </div>

         <div class="header-60-width row text-center justify-content-center mt-4">

              <div 
                v-for="(brand, index) in brands" 
                :key="index" 
                class="col-md-3 col-12 p-4">

                <img  class="" :src="brand.image"  :alt="brand.name" height="110px" width="auto"  />
                <div class="font-weight-bold font-size-18 text-primary mb-4" :class="brand.highlight ? 'text-warning' : ''">{{ brand.name }}</div>
                    
                    </div>

           
          </div>
    </div>

    <div class="mt-5 mb-5">


    </div>
    </div>



   


    <!-- contact us -->
    <div id="contactus" class="bg-white pt-0">
         <div class="text-primary text-center font-weight-bold " style="font-size:2rem;">
            Contactez-nous
          </div>

      <hr class="separator-line mt-3 mb-3">

      <Contactus />

    </div>

    <!-- NOS REFERENCES -->
    <div id="partners" class="bg-white pt-md-5 pt-5 mb-5 pb-5">
        <div class=" ">

          <div class="text-primary text-center font-weight-bold " style="font-size:2rem;">
              Nos partenaires
          </div>

            <hr class="separator-line mt-3 mb-3">

            <div class="header-60-width font-size-20 mx-auto text-primary text-wrap mt-5  text-justify" >
Depuis sa création, SOPIQ a fait le choix de distribuer exclusivement des pièces issues des plus
grands équipementiers de l’industrie automobile.
Notre engagement à fournir des pièces certifiées Qualité Origine vous garantit la traçabilité, la
performance et la fiabilité des produits proposés.
Nous collaborons avec des groupes internationaux reconnus pour l’excellence de leurs
fabrications et leur présence en première monte auprès des plus grandes marques
automobiles.
Distribuer ces marques de référence, c’est pour nous un gage de sérieux pour vous une
assurance de qualité.
      </div>

            <div class="container py-5 p-2 mt-4">
            <swiper :options="swiperOption" class="reference-swiper">
              <!-- <swiper-slide v-for="(logo, index) in referencesLogos" :key="index"> -->
                <swiper-slide v-for="index in 28" :key="index">
                <div class="card border-0 shadow-sm text-center p-3 logo-card ">

                  <img :src="require(`@/assets/images/references/${index}.png`)" :alt="`Reference logo ${index}`" class="img-fluid mx-auto d-block logo-img" />
                </div>
              </swiper-slide>
            </swiper>
          </div>

        </div>
    </div>

  </Layout>
</template>

<style scoped>




.banner-overlay {
  background: /*linear-gradient(#ffffff00, rgb(201 194 194 / 34%));*/
linear-gradient(180deg, rgb(255 255 255 / 0%) 53%, rgb(82 16 16 / 37%) 89%);
  /*linear-gradient(180deg, rgb(255 255 255 / 0%) 53%, rgb(201 194 194 / 37%) 89%)*/

  background-size: cover;
  background-position: center;
  
  /* Create a slight blur effect */
  /*filter: blur(5px);*/
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  justify-content: center;
  display: flex;
  align-items: center;
  text-align: center;
  
  transition: filter 0.3s ease, opacity 0.3s ease;
}

/* Hover Effect (Optional: Adds a modern interaction on hover) */
/* .banner-overlay:hover {
  filter: blur(5px);
  opacity: 0.8; 
} */

.banner-title-white {
  font-size:3rem;            
  letter-spacing: 2px;
 /* text-shadow: 2px 2px 10px rgba(0, 0, 0, 0.6); font-weight: 700;*/
  text-shadow: 2px 2px 10px #fff; font-weight: 700;
}

.banner-title {
  font-size:3rem;            
  letter-spacing: 2px;
  text-shadow: 2px 2px 10px rgba(0, 0, 0, 0.6); 
  font-weight: 700;
}

.new-brands-row {
  display: flex;
  gap: 28px;
  margin: 0 0 16px;
}

.new-brand {
  display: flex;
  flex-direction: column;
  min-width: 84px;
}

.new-brand-label {
  align-self: flex-start;
  padding: 1px 5px;
  color: #fff;
  background-color: #d90100;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 1px;
  line-height: 1.2;
}

.new-brand-name {
  padding-top: 4px;
  color: #fff;
  font-size: 1.15rem;
  font-weight: 700;
  line-height: 1.35;
}

.mobile-new-brands {
  justify-content: center;
  gap: 8px;
  margin: 0 auto;
}

.mobile-new-brands .new-brand {
  min-width: 68px;
  text-align: left;
}

.mobile-new-brands .new-brand-name {
  color: #121212;
  border-bottom-width: 2px;
  font-size: 0.9rem;
}

@media (min-width: 768px) {
  .banner-title {
    font-size: 4rem;
  }
}

/* Mobile Version */

.banner-title-dark {
  font-size:3rem;            
  letter-spacing: 2px;
 /* text-shadow: 2px 2px 10px rgba(0, 0, 0, 0.6); font-weight: 700;*/
  text-shadow: 2px 2px 10px #121212; font-weight: 700;
}
.banner-title-mobile {
  font-size:2rem;            
  letter-spacing: 2px;
  text-shadow: 2px 2px 10px #fff; 
  font-weight: 700;
}





.carousel-caption {
  position: absolute;
  padding-left: 5%;
  top: 48%;
  left: 0;
  transform: translateY(-50%);
  z-index: 2;
}

@media (max-width: 768px) {
  .carousel-caption {
    position: absolute;
    padding-left: 5%;
    top: 30%;
    left: 0;
    transform: translateY(-50%);
    z-index: 2;
  }
}

.left-border {
  border-left: 3px solid #137437;
  padding-left: 10px;
}


.header {
    background:  linear-gradient(19deg,#37985b 0%,#137437 , rgba(23, 83, 45, 1) 100%)!important;
    text-align: center;
  }

.header-60-width,
.sub-title-60-width {
  max-width: 80%;
  margin: auto;
}

@media (min-width: 768px) {
  .header-60-width,
  .sub-title-60-width {
      max-width: 70%;
  }
}
.separator-line {
  width: 15%;
  height: 4px;
  background-color: #d90100; /*#f7d584 ;*/
  border: none;
  margin: auto;
}

.sub-title-60-width {
  margin: 30px auto 0;
  color: #f7d584;
}



</style>

<style scoped>
.logo-card {
  border-radius: 10px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  background-color: #fff;
}
.logo-card:hover {
  transform: scale(1.05);
  box-shadow: 0 10px 30px rgba(0,0,0,0.15);
}
.logo-img {
  max-height: 60px;
  object-fit: contain;
}
.swiper-container {
  padding-bottom: 20px;
}
</style>

<style scoped>
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(50px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.fadeInUp {
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.4s ease, transform 0.4s ease;
}

.fadeInUp.animate {
  animation: fadeInUp 0.6s ease-in-out forwards;
}
</style>

<style scoped>






.image-overlay {
  background: #294639c9  ; 
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  justify-content: center;
}


</style>


<style scoped>
.circle-icon {
  display: inline-block;
  background-color: #252525;
  border-radius: 50%;
  padding: 20px;
  width: 120px;
  height: 120px; 
  opacity: 0.7;
  text-align: center;
  justify-content: center;
  align-items: center;
}

.circle-icon img {
  width: 60px;
  height: 60px; 
}

.white-box {
  background-color: #fff;
  max-width: 600px;
  transform: translateY(-100px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  margin: 0 auto;
}

fieldset.scheduler-border {
  border: 2px solid #137437;
  padding: 1.5em;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  background-color: #f9f9f9;
}

legend.scheduler-border {
  font-size: 1.4em;
  font-weight: bold;
  color: #137437;
  padding: 0 10px;
  text-align: center;
}

.control-group {
  margin-top: 10px;
  line-height: 1.6;
}

</style>


<style scoped>
.image-slide-in {
  width: 400px;
  transform: translateX(-100%);
  opacity: 0; 
  transition: transform 1s ease-out, opacity 1s ease-out;
}


.image-slide-in.animate {
  transform: translateX(0);
  opacity: 1;
}

.dashboard-image {
    width: 100%;
    max-width: 600px;
    border: 8px solid #137437;
    border-radius: 10px;
    box-shadow: 0 10px 20px #13743793;
    transform: rotate(0deg); /* Initial rotation */
    transition: transform 1s ease-out, box-shadow 1s ease-out; /* Add transition for rotation */
}

.image-slide-right-in {
    width: 600px;
    transform: translateX(100%); /* Initially off-screen to the right */
    opacity: 0;
    transition: transform 1s ease-out, opacity 1s ease-out; /* Sliding effect */
}

.image-slide-right-in.animate {
    transform: translateX(0) rotate(0deg); /* Slide to normal position and apply rotation */
    opacity: 1;
}

@media (max-width: 450px) {
  .image-slide-in,
  .image-slide-right-in {
    width: 270px;
  }
}

@media (min-width: 450px) and (max-width: 1300px) {
  .image-slide-in,
  .image-slide-right-in {
    width: 360px;
  }
}


  </style>